// removed by extract-text-webpack-plugin
module.exports = {"modal-container":"share-event-modal-container__modal-container__jBmDk","modal-container-above":"share-event-modal-container__modal-container-above__EnVC_ share-event-modal-container__modal-container__jBmDk","modal-container-below":"share-event-modal-container__modal-container-below__2fkY7 share-event-modal-container__modal-container__jBmDk","modal-content":"share-event-modal-container__modal-content__1xB8T","icon-container":"share-event-modal-container__icon-container__Z711Z","icon":"share-event-modal-container__icon__3AF-m","icon-label":"share-event-modal-container__icon-label__3oC1T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/share-event-modal-container.scss
// module id = 1354
// module chunks = 1